import React from "react";
import styled from "styled-components";
import useDrawerContext from "./useDrawerContext";

const DrawerOverlay = () => {
  const { isOpen, onClose } = useDrawerContext();

  return <Overlay visible={isOpen} onClick={onClose} />;
};

type OverlayProps = {
  visible: boolean;
};

const Overlay = styled.div<OverlayProps>`
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.48);
  transition: opacity 180ms;
  opacity: ${({ visible }) => (visible ? "100%" : 0)};
`;

export default DrawerOverlay;
